import Guard from '@/services/middleware'

const Home = () => import('@/views/dash/logs/Home')
const Log = () => import('@/views/dash/logs/Log')

export default [
    {
        path: '/logs',
        name: 'logs.search',
        component: Home,
        meta: {title: 'Logs', permission: 2, module: 'mod_log'},
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
    {
        path: '/logs/:id',
        name: 'logs.show',
        component: Home,
        meta: {title: 'Detalhes do log', permission: 2, module: 'mod_log'},
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
]